import React from 'react'
import s from './reviews.module.scss'
import { IconStar, IconStarFilled } from '@tabler/icons-react'
import Rating from 'react-rating'
import { TextCollapse } from '@shared/ui/text-collapse/text-collapse'
import { getReviewMessage, getReviewRating, getReviewUserAvatar, getReviewUserName } from '@utils/lib/selectReviews'

export const Review = ({review}) => {
	return (
		<div className={s.reviewCard}>
			<div className={s.flex}>
				<div className={s.avatar}>
					<img
						src={
							getReviewUserAvatar(review)
								? process.env.REACT_APP_STORAGE_URL + getReviewUserAvatar(review)
								: process.env.REACT_APP_STORAGE_URL + "images/default_avatar.png"
						}
						alt=""
					/>
				</div>
				<div className={s.content}>
					<span className={s.name}>
						{getReviewUserName(review)}
					</span>
					<Rating className={s.reviewStars} fullSymbol={<IconStarFilled size={18} className={s.star}/>} emptySymbol={<IconStar size={18} className={s.star}/>} readonly={true} initialRating={getReviewRating(review)}/>
				</div>
				<TextCollapse className={s.reviewText} maxHeight={46.8}>{getReviewMessage(review)}</TextCollapse>
			</div>
		</div>
	)
}
